// Domain
const DOMAIN = 'lending.services.public.onboarding.lzOnboarding.contractContainer.tooltip.';

const INFO_TOOLTIP = `${DOMAIN}info`;
const TITLE_TOOLTIP = `${DOMAIN}title`;

export {
  INFO_TOOLTIP,
  TITLE_TOOLTIP,
};
